var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card v-center"},[_c('QuestionCircleIcon'),_vm._v(" "+_vm._s(_vm.$t('wallet.how_to_earn_more', { snName: _vm.selectedSn.name, snNameRu: _vm.selectedSn.nameRu }))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }